module.exports = __webpack_public_path__ + "static/media/down-arrow-green.4a41af99.svg";